import React, { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import CustomerForm from '../../components/pageModule/Customers/CustomerForm';
import { updateCustomer, fetchCustomer, setSelected, clearCurrentCustomer } from '../../store/modules/customer/customerActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const CustomersEdit = () => {
    const customerState = useSelector(state => state.customer);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);

    const handleUpdate = async (formData) => {
        try {
            const response = await dispatch(updateCustomer(id, formData));
            toast.success('Customer updated successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error updating customer', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        fetchSingle: (id) => dispatch(fetchCustomer(id)),
        update: handleUpdate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentCustomer())
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async (id) => {
        try {
            const data = await actions.fetchSingle(id);
            if(data) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [actions]);

    // Initial data fetch
    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    // Cleanup when component unmounts
    useEffect(() => {
        return () => {
            actions.clearCurrent();
        };
    }, [actions]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <CustomerForm 
                                    initialData={customerState.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.update(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error updating customer:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CustomersEdit; 